import styled from 'styled-components';

const Content = styled.div<{ textLeft?: boolean }>`
	display: flex;
	flex-direction: column;
	flex: 1;
	justify-content: center;
	margin: 0 auto;
	max-width: 20rem;
	text-align: ${(props) => (props.textLeft ? 'left' : 'center')};
	width: 100%;
	gap: 1.5rem;
`;

export default Content;
